import { action } from 'satcheljs';
import type { OwaDate } from 'owa-datetime';
import type {
    QuickComposeControl,
    QuickComposeToFullComposeEntryType,
} from 'owa-calendar-helpers-types/lib/ComposeMetricTypes';
import type { TimeChangeActionType } from 'owa-calendar-helpers-types/lib/TimeChangeActionType';
import type { QuickComposePivotType } from 'owa-calendar-helpers-types/lib/ComposeTypes';

/**
 * Stamps the current form's opened time to MetricsInfo. Resets opened time stamps for the next form
 */
export const logComposeFormOpenedTimes = action('logComposeFormOpenedTimes');

/**
 * Increases the time spent in the room booking panel metric
 */
export const increaseTimeSpentInRoomBookingPanel = action(
    'increaseTimeSpentInRoomBookingPanel',
    (timeInRoomBookingPanelSession: number) => ({
        timeInRoomBookingPanelSession: timeInRoomBookingPanelSession,
    })
);

/**
 * Logs the number of times and duration for using a quick compose control
 */
export const logQuickComposeControlUsed = action(
    'logQuickComposeControlUsed',
    (control: QuickComposeControl, isFocus: boolean) => ({
        control,
        isFocus,
    })
);

/**
 * Action called to log the scheduling grid's usage.
 */
export const logSchedulingGridUsed = action('logSchedulingGridUsed ');

/**
 * Action called to log the time suggestion's start time for the last set of suggestions
 */
export const logTimeSuggestionStartLastSet = action(
    'logTimeSuggestionStartLastSet',
    (suggestionStart: OwaDate) => ({ suggestionStart })
);

export const clearTimeSuggestionStartLastSet = action('clearTimeSuggestionStartLastSet');

/**
 * Action called to log the time suggestion's start time for the first set of suggestions
 */
export const logTimeSuggestionStartFirstSet = action('logTimeSuggestionStartFirstSet');

export const clearTimeSuggestionStartFirstSet = action('clearTimeSuggestionStartFirstSet');

export const initializeTimeSuggestionMetricsInfo = action('initializeTimeSuggestionMetricsInfo');

export const logTimeSuggestionShown = action(
    'logTimeSuggestionShown',
    (suggestionsCount: number) => ({ suggestionsCount })
);

export const logTimeSuggestionClickedIndex = action(
    'logTimeSuggestionClickedIndex',
    (suggestionIndex: number) => ({ suggestionIndex })
);

export const logTimeSuggestionNotFoundCount = action('logTimeSuggestionNotFoundCount');

export const logTimeSuggestionSAClickedCount = action('logTimeSuggestionSAClickedCount');

export const logTimeSuggestionInteraction = action('logTimeSuggestionInteraction');

export const logFindMeetingTimesRequestId = action(
    'logFindMeetingTimesRequestId',
    (findMeetingTimesRequestId: string) => ({ findMeetingTimesRequestId })
);

export const logChangeTimeActions = action(
    'logChangeTimeActions',
    (sourceAction: TimeChangeActionType) => ({ sourceAction })
);

export const logQuickComposeToFullComposeEntryType = action(
    'logQuickComposeToFullComposeEntryType',
    (entryType: QuickComposeToFullComposeEntryType) => ({ entryType })
);

export const logQuickComposePivotType = action(
    'logQuickComposePivotType',
    (pivot: QuickComposePivotType) => ({ pivot })
);

export const logIsBusyResourceSendClicked = action(
    'logIsBusyResourceSendClicked',
    (send: boolean) => ({
        send,
    })
);

/**
 * Action called to log the interactions with the time picker.
 */
export const logStartTimeEndTimeChangedCount = action(
    'logStartTimeEndTimeChangedCount',
    (isStartTime: boolean, isManuallyChanged: boolean) => ({
        isStartTime,
        isManuallyChanged,
    })
);

export const logDidExpandEventBodyEditor = action('logDidExpandEventBodyEditor');
